module.exports = __webpack_public_path__ + "01_very_short_grey.d2f5d5d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_very_short_grey.png
// module id = AOhT
// module chunks = 0